import { Flex, Image } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
	return (
		<Flex alignItems='center' flexDirection='column'>
			<Flex w='100%' alignItems='center' justifyContent='center' py='4px'>
				<Image h='72px' src={require('assets/img/auth/logo.png')} />
			</Flex>
			<HSeparator mb='16px' mt='4px' />
		</Flex>
	);
}

export default SidebarBrand;
